import React from "react";

const CommonLoader = () => {
  return (
    <div className="sk-three-bounce bg-transparent mt-5 col-10">
      <div className="sk-child sk-bounce1"></div>
      <div className="sk-child sk-bounce2"></div>
      <div className="sk-child sk-bounce3"></div>
    </div>
  );
};

export default CommonLoader;
